import React from 'react';
import styles from './TopTable.module.css';
import { formatDate } from '../../../utils/dateUtils';

const ROLE_LABELS = {
  derasar_admin: 'Admin',
  derasar_member: 'Member',
  platform_admin: 'Platform Admin',
};

const TopTable = ({ data, isSuperAdmin }) => {
  if (!data || data.length === 0) {
    return <p className={styles.empty}>No activity data yet.</p>;
  }

  if (isSuperAdmin) {
    return (
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Derasar</th>
            <th>City</th>
            <th>State</th>
            <th>Last Login</th>
            <th>Actions (month)</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={row.derasarId}>
              <td>{row.name}</td>
              <td>{row.city || '—'}</td>
              <td>{row.state || '—'}</td>
              <td>{row.lastLoginAt ? formatDate(String(row.lastLoginAt).split('T')[0]) : '—'}</td>
              <td>{row.activityCount}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th>Member</th>
          <th>Type</th>
          <th>Last Login</th>
          <th>Actions (month)</th>
        </tr>
      </thead>
      <tbody>
        {data.map((row) => (
          <tr key={row.userId}>
            <td>{row.name}</td>
            <td>{ROLE_LABELS[row.systemRole] || row.systemRole || '—'}</td>
            <td>{row.lastLoginAt ? formatDate(String(row.lastLoginAt).split('T')[0]) : '—'}</td>
            <td>{row.activityCount}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TopTable;
